import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { injectNavigationEnd } from 'ngxtension/navigation-end';
import { IMenu, LayoutStore } from '../../stores/layout.store';
import { SideMenuModule } from './side-menu/side-menu.module';
import { TopBar } from './top-bar/top-bar.component';
import { Container } from '../components/container/container.component';

export const menus: IMenu[] = [
  {
    icon: 'mdi:home',
    name: '대시보드',
    href: '/dashboard',
    description: '대시보드',
  },
  {
    icon: 'material-symbols:deployed-code-account-outline',
    name: '회원 관리',
    href: '/user',
    description: '회원 관리',
  },
  {
    icon: 'mdi:office-building-cog-outline',
    name: '기업 관리',
    children: [
      {
        name: '입점사 관리',
        href: '/vendor',
        description: '입점사 관리',
      },
      {
        name: '고객사 관리',
        href: '/client',
        description: '고객사 관리',
      },
    ],
  },
  {
    icon: 'material-symbols:photo-size-select-small-sharp',
    name: '콘텐츠 의뢰 관리',
    href: '/contents-request',
    description: '콘텐츠 의뢰 관리',
  },
  {
    icon: 'material-symbols:credit-card-gear-outline-sharp',
    name: '크레딧 관리',
    children: [
      {
        name: '크레딧 충전/차감 관리',
        href: '/credit-history',
        description: '크레딧 충전/차감 관리',
      },
      {
        name: '크레딧 신청 내역',
        href: '/credit-request',
        description: '크레딧 신청 내역',
      },
    ],
  },
  {
    icon: 'mingcute:question-line',
    name: '서비스 지원 관리',
    children: [
      {
        name: '공지사항 관리',
        href: '/notice',
        description: '공지사항 관리',
      },
      {
        name: '1:1문의 관리',
        href: '/inquiry',
        description: '1:1문의 관리',
      },
      {
        name: '도입문의 관리',
        href: '/introduction-inquiry',
        description: '도입문의 관리',
      },
    ],
  },
  {
    icon: 'material-symbols:web',
    name: '사이트 관리',
    children: [
      {
        name: '회사 정보',
        href: '/company-info',
        description: '회사 정보',
      },
      {
        name: '약관 관리',
        href: '/terms',
        description: '약관 관리',
      },
    ],
  },
  {
    icon: 'material-symbols:computer-outline',
    name: '관리자 관리',
    href: '/admin',
    description: '관리자 관리',
  },
  {
    icon: 'mdi:file-cog-outline',
    name: '빌드파일 관리',
    href: '/build-file',
    description: '빌드파일 관리',
  },
  // {
  //   icon: 'material-symbols:drive-file-rename-outline-outline',
  //   name: '만족도 조사 관리',
  //   href: '/survey',
  //   description: '만족도 조사 관리',
  // },
];

@Component({
  host: {
    ngSkipHydration: 'true',
  },
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  standalone: true,
  imports: [RouterOutlet, CommonModule, TopBar, SideMenuModule, Container],
})
export class LayoutComponent implements OnInit {
  readonly store = inject(LayoutStore);
  readonly router = inject(Router);

  currentMenu = this.store.currentMenu;
  currentChildMenu = this.store.currentChildMenu;
  path = this.store.path;
  menus = this.store.menus;
  navigationEnd$ = injectNavigationEnd();

  ngOnInit(): void {
    this.store.setMenus(menus);
    this.store.setPath(this.router.url);

    this.navigationEnd$.subscribe({
      next: () => {
        this.store.setPath(this.router.url);
      },
    });
  }

  navigate(menu: IMenu) {
    this.router.navigateByUrl(menu.href!);
  }
}
